import { Box, Typography } from '@material-ui/core';
import React from 'react';

import SubmitIcon from '../../common/images/dashboard/submit-project.png';
import { Button } from '../core/button/Button';
import styles from './DashboardFund.module.css';

export interface DashboardFundProps {
  fundOnClick: () => void;
}

export const DashboardFund: React.FC<DashboardFundProps> = props => {
  const { fundOnClick } = props;
  return (
    <Box
      className={`${styles.background} m-5 md:m-0 lg:w-96 lg:h-130 p-5 flex flex-col gap-3 justify-center items-center rounded-lg flex-grow`}
    >
      <img src={SubmitIcon} alt="submit" className="w-11/12" />
      <div className={styles.title + ' text-center md:text-left'}>
        launch project
      </div>
      <Typography variant="body2" className="text-center">
        Are you a filmmaker with a vision? Submit a project proposal for a
        chance to have your idea funded.
      </Typography>
      <Button kind="secondary" className="w-full" onClick={fundOnClick}>
        Submit a Project
      </Button>
    </Box>
  );
};
